import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Grid } from '@mui/material';
import { loadShareholdersSummary } from '../actionCreators';
import { getShareholdersSummary, getShareholdersSummaryIsLoaded } from '../selectors';
import { useTranslation } from 'react-i18next';

const OfferPartnerShareholdersSummary = ({ documentId, siteId, partnerId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const shareholdersSummary = useSelector(state => getShareholdersSummary(state, partnerId), shallowEqual);
  const isSummaryLoaded = useSelector(state => getShareholdersSummaryIsLoaded(state, partnerId), shallowEqual);

  useEffect(() => {
    if (!isSummaryLoaded && partnerId) {
      dispatch(loadShareholdersSummary(documentId, siteId, partnerId));
    }
  }, [isSummaryLoaded, dispatch, documentId, siteId, partnerId]);

  if (!isSummaryLoaded || !shareholdersSummary || shareholdersSummary.length === 0) {
    return null;
  }

  const shareholdersFiltered = shareholdersSummary.filter(x => x.isRealBeneficiary);

  return (
    <>
      {isSummaryLoaded && (
        <Grid container>
          {shareholdersFiltered
            .sort((a, b) => b.sharePercent - a.sharePercent)
            .map((shareholder, index) => {
              return (
                <Grid item xs={3} key={shareholder.shareHolderPartnerName + ' ' + index + '_key'}>
                  <strong>{shareholder.shareHolderPartnerName || ''}: </strong>
                  <span>{t('PERCENT_NUMBER', { number: shareholder.sharePercent })}%</span>
                </Grid>
              );
            })}
        </Grid>
      )}
    </>
  );
};

OfferPartnerShareholdersSummary.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  partnerId: PropTypes.number.isRequired
};

export default OfferPartnerShareholdersSummary;
